import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import m from "definedMessages";
import Page from "components/base/Page";
import { Spacer } from "components/base/Spacer";
import PageHeader from "components/base/PageHeader";
import { BaseToggle } from "components/base/BaseToggle";
import { useWindowWidth } from "hooks";
import { getServiceByLocation } from "utils/helpers";
import { withTranslation } from "hoc/WithTranslation";
import { LOCAL_STORAGE_CLI_FILTERS_DIALER } from "const";
import CLITable from "./CLITable";
import CLIFilters from "./CLIFilters";


const CLI = ({
    count,
    service,
    cliList,
    cliLoading,

    getCLIList,
    formatMessage
}) => {

    const defaultFilter = { str: "" };
    const savedTableFilter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_CLI_FILTERS_DIALER)) || {};

    const [filter, setFilter] = useState({ ...defaultFilter, ...savedTableFilter });
    const [isAuth, setIsAuth] = useState(false);

    const location = useLocation();

    const resizedWidth = useWindowWidth();
    const isMobile = resizedWidth < 768;

    const prevServiceRef = useRef(service);
    useEffect(() => {
        const prevService = prevServiceRef.current;
        if (prevService !== null && service !== prevService) {
            setFilter(defaultFilter);
        }
        prevServiceRef.current = service;
    }, [service, defaultFilter]);

    useEffect(() => {
        if (filter?.str) {
            const currentService = service !== null ? service : getServiceByLocation(location);
            getCLIList(currentService, filter, isAuth);
        }
    }, [isAuth]);

    useEffect(() => {
        localStorage.removeItem(LOCAL_STORAGE_CLI_FILTERS_DIALER);
        setFilter(defaultFilter);
    }, [service]);

    const onChangeFilters = (value) => {
        localStorage.setItem(LOCAL_STORAGE_CLI_FILTERS_DIALER, JSON.stringify(value));
        setFilter(value);

        getCLIList(service, value, isAuth);
    };

    const changeTab = (value) => {
        setIsAuth(value);
    };

    return (<Page>
        <PageHeader title={formatMessage(m.cliLookup)} />
        <BaseToggle
            size="lg"
            unCheckedChildren={formatMessage(m.dialerTraffic)}
            checkedChildren={formatMessage(m.otp)}
            defaultChecked={isAuth}
            onChange={value => changeTab(value)}
        />

        <Spacer size={30} />

        <CLIFilters
            onChangeFilter={onChangeFilters}
            loading={cliLoading}
            savedTableFilter={filter}
            defaultFilter={defaultFilter}
            service={service}
            spAuth={isAuth}
            formatMessage={formatMessage}
        />

        <Spacer />

        <CLITable
            data={cliList}
            filter={filter}
            spAuth={isAuth}
            service={service}
            loading={cliLoading}
            count={count}
            formatMessage={formatMessage}
        />
    </Page>);
};


export default withTranslation(CLI);